import { CaixaProps } from "../../components/Estrutura/Caixa";

export const acessorios: CaixaProps[] = [
    {
    nome: "Pedal duplo bateria",
    descricao: "Pedal duplo para bateria",
    img: "/assets/Estudio/IMG_4362.jpg",
  },
  {
    nome: "Pedestais de microfones (15x)",
    descricao: "Pedestais de microfones ajustáveis",
    img: "", 
  },
  {
    nome: "Pedestais de guitarras/violões/baixos (10x)",
    descricao: "Pedestais de guitarras/violões/baixos",
    img: "",
  },
  {
    nome: "Estantes para partituras (7x)",
    descricao: "Estantes para partituras ajustáveis",
    img: "",
  },
  {
    nome: "Suportes de teclado (2x)",
    descricao: "Suportes de teclado",
    img: "",
  },
  {
    nome: "Bancos de madeira (10x)",
    descricao: "Bancos de madeira de alturas variadas",
    img: "",
  },
  {
    nome: "Bancos de plástico (15x)",
    descricao: "Bancos de plástico empilháveis",
    img: "",
  },
  {
    nome: "Ar condicionado (4x)",
    descricao: "Ar condicionado em todas as salas de ensaio/gravação e sociais",
    img: "",
  }
];